import { Component, Injector, OnInit } from '@angular/core';
import { QuoteSteps } from 'src/app/models/enums/quote-steps';
import { QuoteStepBase } from '../../quote-step-base/quote-step-base';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';
import { StepStateOptions } from 'src/app/models/app/step-state-options';
import { QuoteContainerComponent } from '../../../components/quote-container/quote-container.component';

@Component({
    selector: 'app-captcha-error',
    templateUrl: './captcha-error.component.html',
    styleUrls: ['./captcha-error.component.scss'],
    imports: [QuoteContainerComponent]
})
export class CaptchaErrorComponent extends QuoteStepBase implements OnInit {

    constructor(public override injector: Injector, 
        private authenticationService: AuthenticationService) {
        super(injector);
    }

    ngOnInit(): void {
        this.loadingIndicatorService.hide();
        this.getAgentView();
    }

    private getAgentView() {
        this.authenticationService.getIsAgentView().subscribe(
            {
                next: () => {
                    this.motorQuoteStateService.setStepState(QuoteSteps.none);
                },
                error: (errorResponse: any) => {
                    throw errorResponse;
                }
            }
        );
    }
}
